import { render } from "./NewSlide.vue?vue&type=template&id=527fff08&ts=true"
import script from "./NewSlide.vue?vue&type=script&lang=ts"
export * from "./NewSlide.vue?vue&type=script&lang=ts"

import "./NewSlide.vue?vue&type=style&index=0&id=527fff08&lang=scss"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__